module.exports = __webpack_public_path__ + "img/broadcast-scene-1.8f3ff494.png";